export enum VintageRatingEnum {
  UNKNOWN = "unknown",
  NORMAL = "normal",
  BELOW_THRESHOLD = "below-threshold",
}
